// @ts-nocheck
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { AI_AGENT_FIELD_LIMITS } from '@/utilities/constant';

const { USER_INSTRUCTION_MAX } = AI_AGENT_FIELD_LIMITS;

export default function InstructionFormDialog({ open, onOpenChange, initial, onSave }: any) {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');

  useEffect(() => {
    if (open) {
      setTitle(initial?.title || '');
      setBody(initial?.body || '');
    }
  }, [open, initial]);

  const handleSave = () => {
    if (!title.trim()) {
      toast.error('Instruction name is required');
      return;
    }
    if (!body.trim()) {
      toast.error('Instruction text is required');
      return;
    }
    onSave({ id: initial?.id, title: title.trim(), body });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>{initial ? 'Edit Instruction' : 'New Instruction'}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="instr-title">Name</Label>
            <Input
              id="instr-title"
              placeholder="e.g. FAQ Flow"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              maxLength={100}
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="instr-body">Instruction</Label>
            <Textarea
              id="instr-body"
              rows={6}
              placeholder="Refer to the uploaded knowledge base to understand how this product helps…"
              value={body}
              onChange={(e) => setBody(e.target.value.slice(0, USER_INSTRUCTION_MAX))}
              maxLength={USER_INSTRUCTION_MAX}
            />
            <p className="text-right text-xs text-muted-foreground">{body.length}/{USER_INSTRUCTION_MAX} characters</p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleSave}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
